const initialState = { isOpen: false, isCustomerOpen: false, open: false, invoices: [], invoiceMaster: null, invoiceDetails: null, alertPopup: false };
export default function invoice(state = initialState) {
  return state;
}
